import React, { useRef, useEffect, useCallback, useState } from "react";
import styled from "styled-components";
import getImg from "../../Utils/getImg";
import Axios from "axios";
import { wrapperEndPoint } from "../../Utils/Api";

const WorkflowsMenu = ({
  isMenuVisible,
  toggleMenu,
  workflowQuestions,
  menuIndex,
  from,
}) => {
  const menuOptionsEl = useRef(null);
  const [isQuestions, setIsQuestions] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [botHeight, setBotHeight] = useState(null); //here
  const [botWidth, setBotWidth] = useState(null);
  const [botTop, setBotTop] = useState(null);
  const [botLeft, setBotLeft] = useState(null);

  const onWindowClick = useCallback(
    (ev) => {
      // const clickOnAction =
      //     menuOptionsEl.current && (ev.target === menuOptionsEl.current || menuOptionsEl.current.contains(ev.target));
      // if (!clickOnAction && isMenuVisible === true) {
      //     setIsQuestions(false);
      //     toggleMenu();
      // }
    },
    [isMenuVisible]
  );

  const showQuestions = (index) => {
    setIsQuestions(true);
    setSelectedIndex(index);
  };

  useEffect(() => {
    //here
    let sfMainContainer = document.getElementById("sf-chat-main-container");

    if (sfMainContainer) {
      setBotWidth(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().width
      );
      setBotHeight(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().height
      );
      setBotTop(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().top
      );
      setBotLeft(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().left
      );
    }

    window.addEventListener("resize", handleResize);
    window.addEventListener("click", onWindowClick);
    return () => window.removeEventListener("click", onWindowClick);
  }, []);

  const handleResize = () => {
    let mainContainer = document.getElementById("sf-chat-main-container");
    if (mainContainer) {
      // setBotHeight(mainContainer.getBoundingClientReact().height);
      // setBotWidth(mainContainer.getBoundingClientReact().width);
      // setBotTop(mainContainer.getBoundingClientReact().top);
      // setBotLeft(mainContainer.getBoundingClientReact().left);
      setBotHeight(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().height
      );
      setBotWidth(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().width
      );
      setBotTop(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().top
      );
      setBotLeft(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().left
      );
    }
  };

  //css
  //height:calc(${botHeight}px - 80px);
  const MenuOptions = styled.div`
    position: fixed;
    display: ${(props) => (props.isMenuVisible ? "block" : "none")};
    height: ${botHeight}px;
    width: ${botWidth}px;
    top:  ${botTop}px;
    left:  ${botLeft}px;

    background-color: #fcfcfc;
    z-index: 10000;
   // margin-left:-16px;

   
    
    //background:red;
    
    .menu-options-head{
        display: flex;
        height:56px;

        .active-option{
            display: inline-block;
            color: #000;
            width: 100%;
            font-size: 16px;
            // padding: 40px 28px 8px 28px;
            padding: 24px 28px 8px 32px;

        }

        .menu-close-icon-div{
            position: absolute;
            // display: inline-block;
            // top: 28px;
            // right: 16px;
            top: 24px;
            right: 26px;
           // background: #a12124;
            height: 36px;
            width: 36px;
            border-radius: 36px;
            text-align: center;
            cursor:pointer;  
        }

        .menu-close-icon{
            margin-top:5px;
        }
    }

    .menu-options-body{
        display:block;
        height: auto;
        padding-top: 10px;
        overflow: hidden
        overflow-y: auto;
    
        .each-menu-option{
            height:64px;
            width: auto;
            margin: 12px 30px;
            padding: 10px;
            background: #fff;
            border: 0.5px solid #fff;
            border-radius: 8px;
            box-shadow: 0px 8px 8px rgba(0,0,0,0.1);
            cursor: pointer;
        }

        .option-name{
            display: inline-block;
            vertical-align: middle;
            padding: 10px 15px; 
            font-size:15px;
            width:78%;
        }

        .chevron-icon-div{
            display: inline-block;
            vertical-align: middle;
            text-align: right;
            width:20px;
        }
        .chevron-icon{
            width: 100%;
        }

        .question{
            width:100%;
            display: flex;
            justify-content: space-between;
            padding: 10px 10px;
            color: #666666;
            cursor: pointer;
            background: #fff;        
            // &:not(:last-child){
            //     border-bottom: solid 1px #e2e2e2;
            // }

            &:hover{
                color: #000;
            }
        }
    .question-text{
        max-width: 80%;
    }
  }

    .questions-wrapper{
       
        background: #fff;
        height: calc(${botHeight}px - 105px);
        width: ${botWidth}px;
        padding: 12px 16px 40px 24px;
        /* overflow-y:scroll; */
        -ms-overflow-style: none;  /* IE and Edge */
        /* scrollbar-width: none; only on dev(uat) */
        // margin-left:-4%;
        // margin-top:6%;

        ::-webkit-scrollbar {
            width: 9px;
            height: 5px;
        }
    
        ::-webkit-scrollbar-track {
            background: #f7f7f7;
            height: 50px;
        }
    
        ::-webkit-scrollbar-button {
            height: 3px;
        }
    
        ::-webkit-scrollbar-thumb {
            height: 8px;
            border-radius: 3px;
            background-color: #56a0d3;
        }

    }

`;

  const sendAnalyticsforQuickLink = (data) => {
    let analyticsData = {
      name: data,
      type: "Quick Link",
      action: data,
      botid: "vYdoWvH2CVMbJOGnAB11VA==",
    };
    //  console.log(analyticsData);

    //     let analyticsURL="https://chatbotdev.rbl.bank.in/rcb/GenericChatBot/bannerMenuAnalytics"
    // let analyticsURL = "https://chatbotpre.rbl.bank.in/bannerMenuAnalytics";
    Axios.post(wrapperEndPoint.analyticsURL, analyticsData)
      // .then(response => response.data)
      .then((response) => {
        console.log(response); //handle sucess
      })
      .catch((error) => {
        console.log(error); //handle error
      });
  };

  return (
    <MenuOptions isMenuVisible={isMenuVisible} from={from} ref={menuOptionsEl}>
      <div className="menu-options-head">
        <div className="active-option">
          {workflowQuestions[menuIndex].category} Services
        </div>
        {/* <img className="menu-close-icon" src={getImg(`menu-icons/cross-black.svg`)} onClick={()=>{console.log("close");setIsQuestions(false);toggleMenu();}} alt="menu close icon" /> */}
        <div className="menu-close-icon-div">
          <img
            className="menu-close-icon"
            src={getImg(`menu-icons/cross-black.svg`)}
            onClick={() => {
              setIsQuestions(false);
              toggleMenu();
            }}
            alt="menu close icon"
          />
        </div>
      </div>
      <div className="menu-options-body">
        {/* {
                    workflowQuestions.map(({ displayText, actionText }, j) => {
                        return <div key={j} className="question" onClick={() => { window.autosubmit(actionText,false,'QuickLinkMenu'); toggleMenu(); }}>
                            <div className="question-text">{displayText}</div>
                            <img src={getImg(`menu-icons/arrow.svg`)} alt="menu open icon" />
                        </div>
                    })
                } */}
        {!isQuestions ? (
          //     workflowQuestions.map((item, j) => {
          //         return <div key={j} className="question" onClick={() => { showQuestions(j) }}>
          //             <div className="question-text">{item.category}</div>
          //             <img src={getImg(`menu-icons/arrow.svg`)} alt="menu open icon" />
          //         </div>
          //     })
          // :
          <div className="questions-wrapper">
            {workflowQuestions[menuIndex].submenu.map(
              ({ displayText, actionText }, j) => {
                return (
                  <div>
                    {actionText.indexOf("https") > -1 ? (
                      <div
                        key={j}
                        className="question"
                        onClick={() => {
                          sendAnalyticsforQuickLink(displayText, "");
                          setIsQuestions(false);
                          toggleMenu();
                        }}
                      >
                        <a
                          className="question-text"
                          target="_blank"
                          href={actionText}
                        >
                          {displayText}
                        </a>
                        <div className="chevron-icon-div">
                          <img
                            className="chevron-icon"
                            src={getImg(`menu-icons/icon_chevron_blue.svg`)}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        key={j}
                        className="question"
                        onClick={() => {
                          sendAnalyticsforQuickLink(
                            displayText,
                            "Query submitted"
                          );
                          window.autosubmit(actionText, false, "QuickLinkMenu");
                          setIsQuestions(false);
                          toggleMenu();
                        }}
                      >
                        <div className="question-text">{displayText}</div>
                        <div className="chevron-icon-div">
                          <img
                            className="chevron-icon"
                            src={getImg(`menu-icons/icon_chevron_blue.svg`)}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                );
              }
            )}
          </div>
        ) : null}
      </div>
    </MenuOptions>
  );
};

export default WorkflowsMenu;
